module.exports = __webpack_public_path__ + "img/logo-nova.427d06ee.png";